import { MemberProfileShort } from 'cwp-components/CWP Sections/MemberProfile/MemberProfileShort'
import SeeMore from 'cwp-components/SeeMore'
import { FindLegalDocument } from './FindLegalDocument'
import LoadingSpinner from 'cwp-components/base/LoadingSpinner'

interface ShortProfileResultsProps {
  shortProfiles: any
  hasMoreShortProfiles: any
  handleSeeMore: any
  totalShortProfiles: number
  isMoreLoading: boolean
  shortProfilePage: number
}

export const ShortProfileResults = ({
  shortProfiles,
  hasMoreShortProfiles,
  handleSeeMore,
  totalShortProfiles,
  isMoreLoading,
  shortProfilePage
}: ShortProfileResultsProps) => {

  return (
    <div className='min-h-[500px]'>
      <div className='flex justify-center md:justify-between items-center'>
        {totalShortProfiles > 0 ? (
          <>
            <p className='hidden md:block text-[#001A3D] text-base font-medium'>
              {(shortProfilePage + 1) * 10}{' of '}{totalShortProfiles}{' '}
              {totalShortProfiles === 1 ? 'result' : 'results'}
            </p>
            <FindLegalDocument className='hidden md:block ' />
          </>
        ) : (
          <p className='text-[#001A3D] text-xs md:text-base font-medium'>
            No results for your search.
          </p>
        )}
      </div>
      <div className='flex justify-center flex-wrap gap-[30px] md:justify-left my-10'>
        {shortProfiles.map((data, idx) => (
          <MemberProfileShort key={idx} profile={data} />
        ))}
      </div>
      {hasMoreShortProfiles && shortProfiles.length > 0 && (
        <>
          {isMoreLoading ? (
            <div className=' my-4 h-full sm:mx-10 text-center pt-10'>
              <h1 className='text-[#405985] text-lg font-bold mb-8'>
                Loading more profiles...
              </h1>
              <LoadingSpinner />
            </div>
          ) : (
            <div className='flex justify-end mb-6'>
              <SeeMore onClick={handleSeeMore} />
            </div>
          )}
        </>
      )}
    </div>
  )
}
